import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {GroupMember} from '../../../graphql/groups.datatypes';
import {gqlGroupMember} from '../getGroupMember.api';

export interface CreateGroupMemberVars {
  first_name: string
  last_name: string
  group_role: number
  tour_role: number
  group_id?: number
  user_id?: number
  email?: string
  cellphone_code?: string
  cellphone?: string
  dob?: string
  validated?: boolean
  cancelled?: boolean
  disabled?: boolean
  authorised?: boolean
}

export interface CreateGroupMemberInput {
  data: CreateGroupMemberVars
}

interface CreateGroupMemberData {
  createGroupMember: GroupMember
}

export const CREATE_GROUP_MEMBER_MUTATION = gql`
    mutation createGroupMember($data: CreateGroupMemberInput!) {
        createGroupMember(data: $data) {
            ${gqlGroupMember}
        }
    }
`;

export const createGroupMember = () => useMutation<CreateGroupMemberData, CreateGroupMemberInput>(
  CREATE_GROUP_MEMBER_MUTATION,
  {
    update: updateCacheByType('GroupMember'),
  }
);

export default createGroupMember;